import type { WaterKind } from "../domain/types";
import { KIND_LABEL, mlText } from "../domain/water";
import { useKaya } from "../store/kayaStore";
import { addWater, removeWater, waterEntry } from "../store/toggles";

/**
 * Logs a drink and offers Undo on it for five seconds (water.md §4.2). Shared by Food's "+ glass"
 * and the Water page, so both say the same thing and undo the same way — by this entry's id,
 * leaving a tombstone, so the undone glass cannot come back from another phone.
 */
export function useLogDrink(): (ds: string, drink: { ml: number; kind: WaterKind; note?: string }) => void {
  const update = useKaya((s) => s.update);
  const showToast = useKaya((s) => s.showToast);
  return (ds, drink) => {
    const e = waterEntry(drink);
    update((d) => addWater(d, ds, e));
    showToast(`${KIND_LABEL[e.kind]} · ${mlText(e.ml)}`, {
      action: { label: "Undo", onClick: () => update((d) => removeWater(d, ds, e.id)) },
    });
  };
}
